module.exports = __webpack_public_path__ + "52db4a22899d6a3caf989c1c52ddd5ce.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-8.png
// module id = 3163
// module chunks = 0